import { createSlice } from "@reduxjs/toolkit"
import { getApiLogDetails, getApiLogs } from "store/actions/apilogsAction"

const initialState = {
  loading: true,
  itemsPerPage: 50,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  apiLogsList: [],
  apiLogDetails: {},
}

const usersSlice = createSlice({
  name: "api logs",
  initialState,
  reducers: {
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload
    },
  },
  extraReducers: builder => {
    // FETCH ALL CATEGORIES
    builder
      .addCase(getApiLogs.pending, state => {
        state.loading = true
      })
      .addCase(getApiLogs.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.apiLogsList = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getApiLogs.rejected, (state, action) => {
        state.loading = false
      })
    //   GET API LOG DETAILS
    builder
      .addCase(getApiLogDetails.pending, state => {
        state.loading = true
      })
      .addCase(getApiLogDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.apiLogDetails = data
        }
      })
      .addCase(getApiLogDetails.rejected, (state, action) => {
        state.loading = false
      })
  },
})
export const { setItemsPerPage } = usersSlice.actions

export default usersSlice.reducer
